var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6682 8.49244H8.8907L3.39128 13.9919C4.80163 15.2369 6.65438 15.9924 8.68359 15.9924C12.9339 15.9924 16.4101 12.6778 16.6682 8.49244Z",
    fill: "#4559A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68418 13.2848C1.4391 11.8744 0.683594 10.0217 0.683594 7.99244C0.683594 3.74209 3.99823 0.265911 8.18359 0.0078125V7.78533L2.68418 13.2848Z",
    fill: "#4559A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18359 0.0078125V7.49244H16.6682C16.4203 3.47243 13.2036 0.255714 9.18359 0.0078125Z",
    fill: "#4559A7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.94199b474542b1b632a2bcf9b9a608e8.svg";
export { ForwardRef as ReactComponent };